import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/staff/password/request-reset", { email: email.trim().toLowerCase() }); setSent(true); }
    catch { setSent(true); } finally { setBusy(false); }
  };
  return (
    <div data-testid="page-forgot" className="max-w-md mx-auto px-6 py-16">
      <h1 className="tr-section-title text-3xl lg:text-4xl">{t("auth.forgot_password")}</h1>
      {sent ? (
        <div className="tr-card p-6 mt-8" data-testid="forgot-sent">
          <p className="text-[var(--tr-deep-green)] font-semibold">{t("auth.forgot_sent_title")}</p>
          <p className="mt-2 text-sm text-[var(--tr-muted)]">{t("auth.forgot_sent_body")}</p>
        </div>
      ) : (
        <form onSubmit={submit} className="tr-card p-6 mt-8 space-y-5" data-testid="forgot-form">
          <label className="block">
            <span className="tr-label">{t("auth.email")}*</span>
            <input required type="email" data-testid="forgot-email" className="tr-input" value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <button type="submit" disabled={busy} data-testid="forgot-submit" className="tr-pill-btn tr-btn-primary w-full disabled:opacity-60">
            {busy ? t("common.sending") : t("auth.send_reset_link")}
          </button>
        </form>
      )}
    </div>
  );
}

export function ResetPassword() {
  const { t } = useTranslation();
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error(t("auth.password_too_short")); return; }
    setBusy(true);
    try {
      await api.post("/auth/staff/password/reset", { token, new_password: pw });
      toast.success(t("auth.password_updated"));
      nav("/login/staff");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.error || t("toast.generic_error"));
    } finally { setBusy(false); }
  };
  return (
    <div data-testid="page-reset" className="max-w-md mx-auto px-6 py-16">
      <h1 className="tr-section-title text-3xl lg:text-4xl">{t("auth.reset_title")}</h1>
      <form onSubmit={submit} className="tr-card p-6 mt-8 space-y-5" data-testid="reset-form">
        <label className="block">
          <span className="tr-label">{t("auth.new_password")}*</span>
          <input required type="password" minLength={8} data-testid="reset-pw" className="tr-input" value={pw} onChange={(e) => setPw(e.target.value)} />
        </label>
        <button type="submit" disabled={busy} data-testid="reset-submit" className="tr-pill-btn tr-btn-primary w-full disabled:opacity-60">
          {busy ? t("common.submitting") : t("auth.update_password")}
        </button>
      </form>
    </div>
  );
}
